import { CustomError } from 'ts-custom-error';

export class BrowserOfflineError extends CustomError {
	constructor() {
		super('Browser is offline');
	}
}
